// Small live mockup shown next to each color control, rendered from the
// *current* in-progress palette (not just the one color in isolation) so it
// reads "in symbiosis" with the rest of the configuration - e.g. the button
// preview's label color comes from the palette's mainTextColor, not a fixed
// value, so it stays legible as mainTextColor itself gets edited.
export default function ColorPreview({ kind, value, allValues }) {
  const text = allValues.mainTextColor;
  const secondaryText = allValues.secondaryTextColor;
  const base = allValues.bgColor;
  const lines = allValues.linesColor;

  switch (kind) {
    case 'surface':
      return (
        <div className="color-preview color-preview-surface" style={{ background: value, borderColor: lines }}>
          <span style={{ color: text }}>Aa</span>
        </div>
      );
    case 'text':
      return (
        <div className="color-preview color-preview-text" style={{ background: base, borderColor: lines }}>
          <span style={{ color: value }}>Aa</span>
        </div>
      );
    case 'button':
      return (
        <div className="color-preview color-preview-chip" style={{ background: base, borderColor: lines }}>
          <span className="color-preview-button" style={{ background: value, color: text }}>OK</span>
        </div>
      );
    case 'button-outline':
      return (
        <div className="color-preview color-preview-chip" style={{ background: base, borderColor: lines }}>
          <span className="color-preview-button-outline" style={{ borderColor: value, color: value }}>OK</span>
        </div>
      );
    case 'input':
      return (
        <div className="color-preview color-preview-chip" style={{ background: base, borderColor: lines }}>
          <span className="color-preview-input" style={{ background: value, borderColor: lines, color: secondaryText }}>...</span>
        </div>
      );
    case 'panel':
      return (
        <div className="color-preview color-preview-surface" style={{ background: base, borderColor: lines }}>
          <span className="color-preview-panel-inner" style={{ background: value }} />
        </div>
      );
    case 'overlay':
      return (
        <div className="color-preview color-preview-chip color-preview-overlay-wrap" style={{ background: base, borderColor: lines }}>
          <span className="color-preview-overlay-card" style={{ background: allValues.bgModalColor2 || base }} />
          <span className="color-preview-overlay-glass" style={{ background: value }} />
        </div>
      );
    case 'table-row':
      return (
        <div className="color-preview color-preview-chip color-preview-rows" style={{ background: base, borderColor: lines }}>
          <span style={{ background: value }} />
          <span style={{ background: 'transparent' }} />
          <span style={{ background: value }} />
        </div>
      );
    case 'highlight':
      return (
        <div className="color-preview color-preview-chip" style={{ background: base, borderColor: lines }}>
          <span className="color-preview-highlight" style={{ background: value, color: text }}>Aa</span>
        </div>
      );
    case 'border':
      return (
        <div className="color-preview color-preview-chip" style={{ background: base, borderColor: lines }}>
          <span className="color-preview-border-box" style={{ borderColor: value }} />
        </div>
      );
    case 'border-left':
      return (
        <div className="color-preview color-preview-chip" style={{ background: base, borderColor: lines }}>
          <span className="color-preview-border-left-box" style={{ borderLeftColor: value, color: secondaryText }}>Aa</span>
        </div>
      );
    case 'divider':
      return (
        <div className="color-preview color-preview-chip color-preview-divider-wrap" style={{ background: base, borderColor: lines }}>
          <span style={{ color: secondaryText }}>Aa</span>
          <span className="color-preview-divider-line" style={{ background: value }} />
          <span style={{ color: secondaryText }}>Bb</span>
        </div>
      );
    case 'glow':
      return (
        <div className="color-preview color-preview-chip" style={{ background: base, borderColor: lines }}>
          <span className="color-preview-glow-dot" style={{ boxShadow: `0 0 10px 4px ${value}`, background: base }} />
        </div>
      );
    default:
      return <div className="color-preview color-preview-surface" style={{ background: value, borderColor: lines }} />;
  }
}
